import ProductHighlight from './ProductHighlight';
export default ProductHighlight;